/*
 * Shapes shared by several api/* files. These mirror the GraphQL types in api/schema.gql; each query selects only the
 * fields its screen renders.
 */

export type Track = "uiux" | "graphic" | "video" | "digital";
export type UserRole = "SuperAdmin" | "GigAdmin" | "FinanceAdmin" | "Participant";
export type StepState = "done" | "active" | "locked";
export type KycStatus = "verified" | "pending" | "notstarted";

export interface CheckItem {
  key?: string | null;
  label: string;
  pass: boolean;
  fail: string;
}

export interface GateItem {
  label: string;
  done: boolean;
  detail?: string | null;
}

export interface StepGate {
  pass: boolean;
  items: GateItem[];
}

export interface AIFeedback {
  score: number;
  summary: string;
  strengths: string[];
  improvements: string[];
}

export const CHECK_FIELDS = "key label pass fail";
export const GATE_FIELDS = "gate { pass items { label done detail } }";
export const AI_FIELDS = "score summary strengths improvements";

export interface Platform {
  id: string;
  key: string;
  name: string;
  letter: string;
  description: string;
  referralUrl: string;
}

export interface PlatformProfile {
  id: string;
  profileUrl?: string | null;
  verified: boolean;
  kycStatus?: KycStatus | null;
  kycFileName?: string | null;
  hasKycScreenshot: boolean;
  platform: Platform;
}

export const PLATFORM_FIELDS = "id key name letter description referralUrl";
export const PROFILE_FIELDS = `id profileUrl verified kycStatus kycFileName hasKycScreenshot platform { ${PLATFORM_FIELDS} }`;

export interface Job {
  code: string;
  title: string;
  client: string;
  loc: string;
  posted: string;
  postedH: number;
  urgent: boolean;
  proposals: number;
  lo: number;
  hi: number;
  desc: string;
  keyword: string;
}

export const JOB_FIELDS =
  "code title client loc posted postedH urgent proposals lo hi desc keyword";

export interface RatePackage {
  name?: string | null;
  price?: number | null;
  days?: number | null;
  incl?: string | null;
}

export interface RubricQuestionShape {
  key: string;
  w: number;
  q: string;
  prompt: string;
  lo: string;
  hi: string;
}
